export default "__VITE_ASSET__BDx_Pa9R__"